//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { envConfig } from '@/js/constants';
import PaginationVue from '@/components/PaginationVue.vue';
export default {
  name: 'ExportBaseTabComponent',
  components: {
    PaginationVue: PaginationVue
  },
  props: {
    baseItems: {
      type: Array,
      required: true
    },
    baseHeaders: {
      type: Array,
      required: true
    },
    getDateAndHours: {
      type: Function,
      required: true
    },
    getUseCaseStatus: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      keyTable: 0,
      pagination: {
        base: {
          current: 1,
          limit: envConfig.pagintaionSize,
          total: 0
        }
      }
    };
  },
  methods: {
    stripRlink: function stripRlink(value) {
      return (value || '').replace(/_rlink/gi, '');
    }
  }
};